import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  chats: [],
}

export const chatSlice = createSlice({
  name: 'chats',
  initialState,
  reducers: {
    setChatMessages: (state, action) => {
      state.chats = [...state.chats, action.payload];
    },
    resetChatMsg: (state, action) => {
      state.chats = [];
    },
  },
})

// Action creators are generated for each case reducer function
export const {setChatMessages,resetChatMsg   } = chatSlice.actions

export default chatSlice.reducer;